import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';
import * as VueGoogleMaps from "vue2-google-maps";

import Config from '@/config/vueconfig.js';
import Validator from '@/plugins/Validator.js';
import ga from '@/plugins/GA.js';
import BBEnumCampaignType from '@/plugins/BBEnumCampaignType.js';
import RegExp from '@/plugins/RegExp.js';
import Filter from '@/plugins/Filter.js';
import Account from '@/helper/AccountHelper.js';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.use(VueCookies);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyDnEgxgne2--rT_d3ZWTns0dnkLiKWvfgE",
      libraries: "places" // necessary for places input
    }
});

new Vue({
    router,
    render: h => h(App),
    created: function() {
        Vue.initFinished = false;

        Vue.use(VueAnalytics, {
            id: Vue.bzbsConfig.bzbsGaId,
            autoTracking: {
                page: false
            },
        });

        Account.initial();
    },
}).$mount('#app')
